import { INotifications, IProjectNotifications, IProjectNotificationsInvite } from '@app/@introspection';
import { DateTimeProvider } from '@core/services/date-time/date-time.service';
import { translate } from '@core/translate';
import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { Invitation } from '@shared/icons';

export const isProjectInviteNotification = (n: INotifications) =>
  n.data.__typename === 'ProjectNotifications' && n.data.message.__typename === 'ProjectNotificationsInvite';

export const InviteNotificationTemplate =
  (n: INotifications) =>
  ([notificationService, router]) => ({
    read: n.read,
    html: html`
      <div style="width: 355px">
        <project-invite-template-notifications
          @click=${() => {
            if (!n.read) {
              notificationService.readNotification(n.id).subscribe();
            }
            router.go(`/projects/${n.data['projectId']}`);
          }}
          .notification=${n}
        ></project-invite-template-notifications>
      </div>
    `,
  });
/**
 * @customElement project-invite-template-notifications
 */
@Component({
  selector: 'project-invite-template-notifications',
  styles: [
    css`
      .spacer {
        flex: 1 3 auto;
      }
    `,
  ],
  template(this: ProjectInviteTemplateComponent) {
    const data = this.notification.data as IProjectNotifications;
    const message = data.message as IProjectNotificationsInvite;
    return html`
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 10px;">${Invitation}</div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span>${translate('You have being invited as member inside project')}</span>
            <a href=${`/projects/${data.projectId}`} style="color: blue">${data.projectName}</a>
            <span>${translate('by')}</span>
            <a style="color: blue">${message.from.name}</a>
            <span>${translate('to build awesome things')}</span>
          </div>

          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
  },
})
export class ProjectInviteTemplateComponent extends LitElement {
  @Inject(DateTimeProvider) private dateTimeProvider: DateTimeProvider;
  @property({ type: Object }) notification: INotifications;
}
